import { OnboardingTooltip } from "@/components/note/floating-actions/onboarding-tooltip";

interface AudioCaptureOnboardingProps {
  show: boolean;
  triggerRef: React.RefObject<HTMLElement>;
}

export function AudioCaptureOnboarding({ show, triggerRef }: AudioCaptureOnboardingProps) {
  return (
    <OnboardingTooltip
      title="Mem's capturing everything ✨"
      subtitle="Try talking about what you need to focus on this week and then press Done to see how Mem turns it into a note."
      triggerRef={triggerRef}
      isOpen={show}
      placement="left"
      pointCorner="top-right"
      crossOffset={54}
    />
  );
}
